import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { LabraToolTipV2 } from '@labrav/react-components'
import { useNavigate } from 'react-router-dom'

import { useStyles } from './ProductNameWithExternalLink.styles'

interface ProductNameWithExternalLinkProps {
  productName?: string | React.ReactNode
  productId?: string
}

export const ProductNameWithExternalLink: React.FC<
  ProductNameWithExternalLinkProps
> = ({ productName, productId }) => {
  const navigate = useNavigate()
  const { classes } = useStyles()

  const handleExternalLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (productId) {
      navigate(`/flyout/products-listing/${productId}/details`)
    }
  }

  if (!productName || productName === '-') {
    return <span>{productName || '-'}</span>
  }

  return (
    <div className={classes.root}>
      <span>{productName}</span>
      <LabraToolTipV2
        tooltipPlacement="top"
        description="Go to product details"
      >
        <FontAwesomeIcon
          icon={faArrowUpRightFromSquare}
          onClick={handleExternalLinkClick}
          className={classes.icon}
        />
      </LabraToolTipV2>
    </div>
  )
}
